import settings from '../../assets/settings.json';
import Cookies from 'js-cookie'

function isEncoded(str) {
  // エンコードされた文字列の正規表現パターン
  var encodedPattern = /%[0-9A-F]{2}/gi;

  // 正規表現パターンに一致するかどうかをチェック
  return encodedPattern.test(str);
}



class FunctionFields {

  downloadFile(what_type, staff_token, staff_name){
    let isit_encode_text = isEncoded(staff_name);
    if(isit_encode_text===false){
      staff_name = encodeURI(staff_name);
    }

    const url = settings.API_BASE_URL + 'download_csv/' + '?what_type='+what_type+'&token='+staff_token+'&name='+ staff_name ;
    console.log(url);
    var Httpreq = new XMLHttpRequest();
    Httpreq.open("GET", url, false);
    Httpreq.send(null);
    //var response_obj = JSON.parse(Httpreq.responseText)['data'];
    //console.dir(response_obj);
    //return response_obj;
    return 'ok';

  }



  
}

const addMenuFunction = new FunctionFields();

export { addMenuFunction };